import { Button, ButtonContainer, Callout, Modal } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

type CustomerHappinessIndexTypes = {
    surveyUrl: string;
    handleOpenModal: () => void;
    isModalShown: boolean;
    handleCloseModal: () => void;
};

export const CustomerHappinessIndexUi: React.FC<CustomerHappinessIndexTypes> = ({
    surveyUrl,
    handleOpenModal,
    isModalShown,
    handleCloseModal,
}) => {
    const { t } = useTranslation('customer-happiness-index');

    return (
        <>
            <Callout headingLevel={3} title={t('title')} className={'u-mb'}>
                {t('text')}
                <ButtonContainer center className={'u-mt'}>
                    <Button onClick={handleOpenModal}>{t('button')}</Button>
                </ButtonContainer>
            </Callout>
            <span
                className={'u-font-size-fs-2'}
                dangerouslySetInnerHTML={{
                    __html: t('legal-notice'),
                }}
            />
            <Modal
                shown={isModalShown}
                title={t('confirmation-modal.title')}
                headingLevel={2}
                onClose={handleCloseModal}
                testId={'confirmation-modal'}
            >
                <>
                    {t('confirmation-modal.text')}
                    <div className="u-block-center u-text-center u-mt">
                        <a href={surveyUrl} target="_blank" rel="noopener noreferrer">
                            <Button type="button" onClick={handleCloseModal}>
                                {t('confirmation-modal.button')}
                            </Button>
                        </a>
                    </div>
                </>
            </Modal>
        </>
    );
};
